/**
 * Initializes video facades.
 * Handles swapping the poster image for the iframe on click.
 */
export const initVideoFacades = (): void => {
  // Select all video containers that use the facade pattern (have a trigger)
  const triggers = document.querySelectorAll<HTMLElement>(
    "[data-video-container] [data-video-trigger]"
  );

  if (triggers.length === 0) {
    return;
  }

  triggers.forEach((trigger) => {
    // Ensure we only bind once
    if (trigger.dataset.initialized === "true") return;
    trigger.dataset.initialized = "true";

    trigger.addEventListener("click", () => {
      const container = trigger.closest(".post-content-video__container");
      if (!container) return;

      const template = container.querySelector<HTMLTemplateElement>(
        ".post-content-video__template"
      );

      if (template) {
        // Clone content from template
        const clone = template.content.cloneNode(true) as DocumentFragment;

        // Try to autoplay if possible
        const iframe = clone.querySelector("iframe");
        if (iframe) {
          const src = iframe.getAttribute("src") || "";
          const separator = src.includes("?") ? "&" : "?";

          // Add autoplay parameter
          // Note: Autoplay policies might block audio, but video usually plays.
          iframe.setAttribute("src", src + separator + "autoplay=1");

          // Ensure proper allow attributes for modern browsers
          const currentAllow = iframe.getAttribute("allow") || "";
          const requiredAllow =
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";

          // Simple check to avoid duplicating if WP already added some
          if (!currentAllow.includes("autoplay")) {
            iframe.setAttribute(
              "allow",
              currentAllow ? `${currentAllow}; ${requiredAllow}` : requiredAllow
            );
          }
        }

        // Append iframe and remove facade
        container.appendChild(clone);
        trigger.remove();
      }
    });
  });

  console.log(`[Video] Initialized ${triggers.length} video facades.`);
};
